import Icon, { IconProps } from './Icon';

import GitBranchIcon from '../../../assets/icons/git-branch-01.svg?react';

const GitBranch: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <GitBranchIcon />
        </Icon>
    );
};

export default GitBranch;
